import React from 'react';
import {
  ACTIVITY_ACTION,
  MAINTENANCE_SERVICE_ORDER_PRIORITY,
  PREVENTIVE_TASK_ASSIGNEE_SCOPE,
  PREVENTIVE_TASK_REPEAT_TYPE,
} from '../../../../../config/constants';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import EnumStatus from '../../../../common/EnumStatus';
import IsActive from '../../../../common/cells/IsActive';
import {
  preventiveTaskAssigneeBasicInformationPropTypes,
  preventiveTaskAssigneeBasicInformationDefaultProps,
} from '../proptypes/PreventiveTaskAssigneeProptypes';

const getUserLabel = (user, userId) => {
  if (user && user.fullName && user.username) {
    return `${user.fullName} (${user.username})`;
  }

  if (user && user.fullName) {
    return user.fullName;
  }

  if (user && user.username) {
    return user.username;
  }

  return userId || '-';
};

const PreventiveTaskAssigneeBasicInformationResource = ({
  preventiveTask,
  assignmentScope,
  departamentName,
  areaName,
  positionName,
  userId,
  user,
  active,
}) => (
  <>
    <ResourceProperty label="Código de la Tarea:">
      {preventiveTask && preventiveTask.companyPreventiveTaskId
        ? preventiveTask.companyPreventiveTaskId
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Nombre de la Tarea:">
      {preventiveTask && preventiveTask.name ? preventiveTask.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Tipo de Acción:">
      {preventiveTask && preventiveTask.actionType ? (
        <EnumStatus
          enumObject={ACTIVITY_ACTION}
          enumValue={preventiveTask.actionType}
        />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Prioridad:">
      {preventiveTask && preventiveTask.priority ? (
        <EnumStatus
          enumObject={MAINTENANCE_SERVICE_ORDER_PRIORITY}
          enumValue={preventiveTask.priority}
        />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Frecuencia:">
      {preventiveTask && preventiveTask.repeatType ? (
        <EnumStatus
          enumObject={PREVENTIVE_TASK_REPEAT_TYPE}
          enumValue={preventiveTask.repeatType}
        />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Intervalo:">
      {preventiveTask && preventiveTask.repeatInterval
        ? preventiveTask.repeatInterval
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Notificación Programada:">
      {preventiveTask &&
      preventiveTask.deviation !== null &&
      preventiveTask.deviation !== undefined
        ? `${preventiveTask.deviation} día(s)`
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Tipo de Asignación:">
      <EnumStatus
        enumObject={PREVENTIVE_TASK_ASSIGNEE_SCOPE}
        enumValue={assignmentScope}
      />
    </ResourceProperty>

    {assignmentScope === PREVENTIVE_TASK_ASSIGNEE_SCOPE.AREA.code && (
      <>
        <ResourceProperty label="Departamento:">
          {departamentName || '-'}
        </ResourceProperty>

        <ResourceProperty label="Área:">{areaName || '-'}</ResourceProperty>
      </>
    )}

    {assignmentScope === PREVENTIVE_TASK_ASSIGNEE_SCOPE.ROLE.code && (
      <ResourceProperty label="Rol / Cargo:">
        {positionName || '-'}
      </ResourceProperty>
    )}

    {assignmentScope === PREVENTIVE_TASK_ASSIGNEE_SCOPE.PERSON.code && (
      <ResourceProperty label="Usuario:">
        {getUserLabel(user, userId)}
      </ResourceProperty>
    )}

    <ResourceProperty label="Estado de Asignación:">
      <IsActive value={active} />
    </ResourceProperty>
  </>
);

PreventiveTaskAssigneeBasicInformationResource.propTypes =
  preventiveTaskAssigneeBasicInformationPropTypes;

PreventiveTaskAssigneeBasicInformationResource.defaultProps =
  preventiveTaskAssigneeBasicInformationDefaultProps;

export default PreventiveTaskAssigneeBasicInformationResource;
